module.exports = __webpack_public_path__ + "static/media/31-3.86216e2a.mp3";